<template>
  <vs-popup class="report-generate-popup" id="popup" :title="'REPORT GENERATE'" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <span v-if="is_success">
        <div class="text-lg">
          🕒 Report generation in progress. You'll find it in the “Generated Reports” section once it’s ready.
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button @click="onClickClose" class="mt-2 ml-4" type="border" color="primary">Close & Open Generated
            Reports</vs-button>
        </div>
      </span>


      <ValidationObserver ref="form" v-slot="{ handleSubmit }" v-if="!is_success">
        <form id="report-generate-popup" @submit.prevent="handleSubmit(onClickGenerate)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="Code" name="Code" rules="" v-slot="{ errors }">
                <small class="label">Reference</small>
                <vs-input disabled v-model="details.Code" name="Code" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="details.Name">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="Name" name="Name" rules="" v-slot="{ errors }">
                <small class="label">Reference Name</small>
                <vs-input disabled v-model="details.Name" name="Name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row vx-card card-border no-shadow ml-0">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="templates" name="templates" rules="" v-slot="{ errors }">
                <small class="label">Template(s)</small>

                <table>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(template, index) in templates" :key="index" class="mb-2">
                      <td class="text-warning">{{ template.Brand.toUpperCase() }}</td>
                      <td>
                        <span v-if="!template.s3Key">
                          <span class="text-danger text-sm ml-2">No template file available. Please upload first.</span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="brand" name="brand" rules="required" v-slot="{ errors }">
                <small class="label">Brand</small>
                <v-select :clearable="false" placeholder="" v-model="details.brand" label="Brand"
                  :options="available_templates" :reduce="option => option.Brand" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Generate</vs-button>
            <vs-button @click="open = false" class="mt-2 ml-4" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ReportTemplateRepository = RepositoryFactory.get('report_template')
const ReportRepository = RepositoryFactory.get('report')

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    details: {
      brand: null
    },
    templates: [],
    available_templates: [],
    is_success: false,
    object_name: null,
    assessments_map: {
      hazardinspection: 'Hazard Inspection',
      propertyriskassessment: 'Property Risk Assessment',
      foodsafetyreport: 'Food Safety Report',
      action: 'Action Status Report',
      copeassessment: 'COPE Assessment',
    }
  }
}

export default {
  name: 'AssessmentReportGeneratePopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(details, object_name) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        Object.assign(this.details, details);
        this.object_name = object_name
        await this.fetchTemplateList()
        this.open = true;
      } catch (error) {

      }
    },
    async fetchTemplateList() {
      this.$vs.loading()
      const { data } = (await ReportTemplateRepository.fetchReportTemplates()).data
      this.templates = data.data.filter((x) => x.Name === this.assessments_map[this.object_name])
      this.available_templates = this.templates
      .filter((x) => x.s3Key)
      this.$vs.loading.close()
    },
    async onClickGenerate() {
      await this.$vs.loading({
        container: '#report-generate-popup',
        scale: 0.45
      })
      try {
        await ReportRepository.generateReport(this.details._id, this.object_name,
          { brand: this.details.brand }
        )
        this.is_success = true
      } catch (error) {

      } finally {
        this.$vs.loading.close('#report-generate-popup > .con-vs-loading')
      }
    },
    async onClickClose() {
      this.open = false
      this.$emit('openGeneratedReports')
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.report-generate-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 40% !important;
}
</style>
